import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPin = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M6.549 10.9847L9.19915 8.31587C10.0382 7.42902 10.5 6.29641 10.5 5.12641C10.5 2.63064 8.48123 0.600098 6 0.600098C3.51877 0.600098 1.5 2.63064 1.5 5.12641C1.5 6.29641 1.96177 7.42902 2.81262 8.32833L5.451 10.9847H6.549ZM6 1.8C7.81693 1.8 9.3 3.29173 9.3 5.12631C9.3 5.98181 8.96137 6.81636 8.33674 7.48121L6.04947 9.78462H5.95045L3.66402 7.48259C3.04315 6.82585 2.7 5.98758 2.7 5.12631C2.7 3.29173 4.18307 1.8 6 1.8Z",
					fill: "#005AA0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M1.79999 10.7998V11.9998H10.2V10.7998H1.79999Z",
					fill: "#005AA0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M6.00001 5.7004C5.65801 5.7004 5.40001 5.4424 5.40001 5.1004C5.40001 4.7578 5.65801 4.4998 6.00001 4.4998C6.34201 4.4998 6.60001 4.7578 6.60001 5.1004H7.80001C7.80001 4.0906 7.00921 3.2998 6.00001 3.2998C4.99081 3.2998 4.20001 4.0906 4.20001 5.1004C4.20001 6.1096 4.99081 6.9004 6.00001 6.9004V5.7004Z",
					fill: "#005AA0"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16,
				height: 16,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgPin);
export { ForwardRef as ReactComponent };
